import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../redux/store";
import { useTranslation } from "react-i18next";
import { ShowFrontEndContext } from "../types";
import { NewsInterface } from "../../News/types";
import ToggleImages from "./ToggleImages";
import { pageDirContext } from "../../../App";

const ShowNews: React.FC = () => {
  const { news } = useSelector((state: State) => state.news);
  const { t } = useTranslation();
  const { NewsRef } = useContext(ShowFrontEndContext);

  const { pageDir } = useContext(pageDirContext)

  return (
    <section
      className="my-6 p-6 bg-gray-100 rounded-lg shadow-md"
      ref={NewsRef}
      dir={pageDir} // Apply direction to the section
    >
      {/* Title - Centered */}
      <h2 className="text-main text-center font-bold text-xl md:text-2xl mb-6 border-b-2 border-main pb-2">
        {t("Les Actualités de l'ONMDM")}
      </h2>

      {/* News Container */}
      <div className="grid md:grid-cols-2 gap-6">
        {news.map((actuality: NewsInterface, index: number) => (
          <div
            key={index}
            className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-300"
          >
            {/* News Title */}
            <p className={`text-center text-lg font-bold text-main mb-3 ${pageDir === 'rtl' ? 'text-right' : 'text-left'}`}>
              {actuality.title}
            </p>

            {/* Content */}
            <p className={`text-gray-700 text-sm md:text-base mb-4 ${pageDir === 'rtl' ? 'text-right' : 'text-left'}`}>
              {actuality.content}
            </p>

            {/* Image Toggle Component */}
            <div className="flex justify-center">
              <ToggleImages actuality={actuality} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShowNews;
